module.exports = __webpack_public_path__ + "static/oscar-sosa-706510fa2bae227375bbecad97a54829.jpg";